export default function update(
    action: UpdateTrackAction,
    setTracks: React.Dispatch<React.SetStateAction<{[localId: string]: Track}>>
) {
    const {track} = action;
    const {localId} = track.properties;
    setTracks((latestTracks) => ({
        ...latestTracks,
        [localId]: track,
    }));

    return [localId];
}
